module.exports = __webpack_public_path__ + "static/img/ri-user-add-line.df41ddc6.svg";